<template>
  <div class="member-content">
    <MemberHeader v-if="isMemAuthenticated"></MemberHeader>
    <transition name="fade-in-up">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MemberHeader from "@/view/pages/members/loggedin/MemberHeader.vue";
import { MEMBER_PURGE_AUTH } from '@/core/services/store/member.auth.module';

export default {
  name: "MemberLayout",
  components: {
    MemberHeader,
  },

  mounted() {

  },
  methods: {
    check_refresh_token_expired() {
      if (this.member_refresh_token === null) {
        store.commit(MEMBER_PURGE_AUTH);
      }

      if (!this.member_refresh_token || this.member_refresh_token.length < 16) {
        console.error('check_refresh_token_expired invalid member refresh token view/Layout', this.member_refresh_token);
        return;
      }
      
      const parsed = parseJwt(this.member_refresh_token);
      const cd = dayjs.unix(parsed.exp);
      const now = dayjs();

      console.log('refresh token will expire at ', cd.format('YYYY-MM-DD HH:mm:ss'), 'now is', now.format('YYYY-MM-DD HH:mm:ss'));

      if (cd < now) {
        store.commit(MEMBER_PURGE_AUTH);
      }
    },

  },
  computed: {
    ...mapGetters([
      "isMemAuthenticated",
    ]),

  }
};
</script>

<style lang="css" scoped>

.member-content {
  height: 100vh;
  overflow: auto;
  background-color: white;
}

.page {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

#member-layout-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

#member-layout-content {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  padding: 1rem;
}

</style>